import GeneralStatus from "../Shared/GeneralStatus";

enum KBStatus {
    Draft = GeneralStatus.Pending,
	Published = GeneralStatus.ActiveOrApproved,
	Archived = GeneralStatus.Archived
}

export default KBStatus;



